// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  layoutContainer: {
    name: 'layoutContainer',
    componentName: 'LayoutContainer',
    chunk: () => import(
      /* webpackChunkName: "LayoutContainer" */
      './pages/LayoutContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/LayoutContainer.js')).LayoutContainer
        : currentRouteName === 'layoutContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LayoutContainer })));
    },
    path: '/:context?/:contentPV?/c/:slug',
    channel: null
  },
  siteMap: {
    name: 'siteMapContainer',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      /* webpackChunkName: "SiteMapContainer" */
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SiteMapContainer.js')).SiteMapContainer
        : currentRouteName === 'SiteMapContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map',
    channel: null
  },
  siteMapB2C: {
    name: 'siteMapB2C',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      /* webpackChunkName: "SiteMapContainer" */
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SiteMapContainer.js')).SiteMapContainer
        : currentRouteName === 'siteMapB2C'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map-b2c',
    channel: null
  },
  siteMapB2B: {
    name: 'siteMapB2B',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      /* webpackChunkName: "SiteMapContainer" */
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SiteMapContainer.js')).SiteMapContainer
        : currentRouteName === 'siteMapB2B'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map-b2b',
    channel: null
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});
